import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UsMapService } from "./us-map.service";
import { UsMapComponent } from "./us-map.component";
import { CustomTooltipComponent } from "../custom-tooltip/custom-tooltip.component";
import { AnotherMapComponent } from './another-map/another-map.component';
//import { CustomTooltipComponent } from "./custom-tooltip/custom-tooltip.component";

@NgModule({
  imports: [CommonModule],
  declarations: [UsMapComponent, CustomTooltipComponent, AnotherMapComponent],
  providers: [UsMapService],
  exports: [UsMapComponent],
})
export class UsMapModule {}
